import React from "react";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Accordion from "components/Accordion/Accordion.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import Cached from "@material-ui/icons/Cached";
import Check from "@material-ui/icons/Check";
import Slider from "nouislider";

import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.js";

import suit1 from "assets/img/us/Scene/Scene-kapak.png";
import suit2 from "assets/img/us/Scene/scene1.jpg";
import suit3 from "assets/img/us/Scene/Scene-1.jpg";
import suit4 from "assets/img/us/Scene/Scene-2.jpg";
import suit5 from "assets/img/us/Scene/Scene-3.jpg";
import suit6 from "assets/img/us/Scene/Scene-4.jpg";

import trendyolLogo from "assets/img/logos/trendyol.png";
import hepsiburadaLogo from "assets/img/logos/hepsiburada.png";

const useStyles = makeStyles(styles);

export default function SectionProducts() {
  const classes = useStyles();
  const [checked, setChecked] = React.useState([]);
  const [priceRange, setPriceRange] = React.useState([101, 790]);

  React.useEffect(() => {
    if (!document.getElementById("sliderRegular").classList.contains("noUi-target")) {
      Slider.create(document.getElementById("sliderRegular"), {
        start: priceRange,
        connect: true,
        range: { min: 30, max: 900 },
        step: 1
      }).on("update", function (values) {
        setPriceRange([Math.round(values[0]), Math.round(values[1])]);
      });
    }
    return function cleanup() {};
  }, []);

  const handleToggle = value => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const designers = [
    "Tuğçe Audoire Koleksiyonu", "S. Deren Ekşi Koleksiyonu"
  ];

  const categories = [
    "Zamansız Ajandalar", "Sticker"
  ];
  const products = [
    "The Girl", "Old Town", "Dream","Food and Drinks","Goods and Plants","Woods and Icons","Warm Evening","Scene","Seasons","Far East","Words and Icons"
  ];

  const allProducts = [
    {
      name: "Scene Ajanda",
      image: suit1,
      description: "Zarif ve şık tasarımı ile planlamayı keyifli hale getirir.",
      category: "Zamansız Ajandalar",
      designer: "S. Deren Ekşi Koleksiyonu",
      price: 250
    },
    {
      name: "Foods and Drinks Sticker",
      image: suit2,
      description: "Günlük notlarınız için ideal, minimal tasarımlı defter.",
      category: "Sticker",
      designer: "Notio",
      price: 130
    },
    {
      name: "Cüzdan",
      image: suit3,
      description: "Kaliteli deri cüzdan, hem şık hem fonksiyonel.",
      category: "Cüzdan",
      designer: "Craftmark",
      price: 320
    },
    {
      name: "Kalem",
      image: suit4,
      description: "Özenle seçilmiş yazım araçları ile yazmak artık daha keyifli.",
      category: "Kalem",
      designer: "Mürekkep Kalemler",
      price: 160
    },
    {
      name: "Tote Çanta",
      image: suit5,
      description: "Günlük kullanım için geniş hacimli ve zarif çanta.",
      category: "Çanta",
      designer: "Studio Paper",
      price: 290
    },
    {
      name: "Planner Seti",
      image: suit6,
      description: "Ajanda, not defteri ve kalemden oluşan harika bir hediye seti.",
      category: "Planlayıcı Set",
      designer: "Kisetsu Tasarım",
      price: 410
    }
  ];

  const filteredProducts = allProducts.filter(p => {
    const priceOk = p.price >= priceRange[0] && p.price <= priceRange[1];
    const categoryOk = checked.some(i => categories[i] === p.category);
    const designerOk = checked.some(i => designers[i - 100] === p.designer);
    return priceOk && (categoryOk || designerOk || checked.length === 0);
  });

  return (
    <div id="products-section" className={classes.section}>
      <div className={classes.container}>
      <h2 style={{ marginTop: "40px" }}>Ürünlerimiz</h2>
        <GridContainer>
          <GridItem md={3} sm={12}>
            <Card plain>
              <CardBody className={classes.cardBodyRefine}>
                <h4 className={classes.cardTitle + " " + classes.textLeft}>
                  Filtrele
                  <Tooltip title="Filtreyi Sıfırla" placement="top" classes={{ tooltip: classes.tooltip }}>
                    <Button
                      link
                      justIcon
                      size="sm"
                      className={classes.pullRight + " " + classes.refineButton}
                      onClick={() => setChecked([])}
                    >
                      <Cached />
                    </Button>
                  </Tooltip>
                  <Clearfix />
                </h4>
                <Accordion
                  active={[0, 1, 2]}
                  activeColor="rose"
                  collapses={[
                    {
                      title: "Fiyat Aralığı",
                      content: (
                        <CardBody className={classes.cardBodyRefine}>
                          <span className={classNames(classes.pullLeft, classes.priceSlider)}>₺{priceRange[0]}</span>
                          <span className={classNames(classes.pullRight, classes.priceSlider)}>₺{priceRange[1]}</span>
                          <br /><br />
                          <div id="sliderRegular" className="slider-rose" />
                        </CardBody>
                      )
                    },
                    {
                      title: "Ürün",
                      content: (
                        <div className={classes.customExpandPanel}>
                          {categories.map((item, index) => (
                            <FormControlLabel
                              key={index}
                              control={
                                <Checkbox
                                  disableRipple
                                  tabIndex={-1}
                                  onClick={() => handleToggle(index)}
                                  checked={checked.indexOf(index) !== -1}
                                  checkedIcon={<Check className={classes.checkedIcon} />}
                                  icon={<Check className={classes.uncheckedIcon} />}
                                  classes={{ checked: classes.checked, root: classes.checkRoot }}
                                />
                              }
                              classes={{ label: classes.label }}
                              label={item}
                            />
                          ))}
                        </div>
                      )
                    },
                    {
                      title: "Tasarımcı",
                      content: (
                        <div className={classes.customExpandPanel}>
                          {designers.map((item, index) => (
                            <FormControlLabel
                              key={index + 100}
                              control={
                                <Checkbox
                                  disableRipple
                                  tabIndex={-1}
                                  onClick={() => handleToggle(index + 100)}
                                  checked={checked.indexOf(index + 100) !== -1}
                                  checkedIcon={<Check className={classes.checkedIcon} />}
                                  icon={<Check className={classes.uncheckedIcon} />}
                                  classes={{ checked: classes.checked, root: classes.checkRoot }}
                                />
                              }
                              classes={{ label: classes.label }}
                              label={item}
                            />
                          ))}
                        </div>
                      )
                    },
                    {
                      title: "Ürün Kategorisi",
                      content: (
                        <div className={classes.customExpandPanel}>
                          {products.map((item, index) => (
                            <FormControlLabel
                              key={index + 100}
                              control={
                                <Checkbox
                                  disableRipple
                                  tabIndex={-1}
                                  onClick={() => handleToggle(index + 100)}
                                  checked={checked.indexOf(index + 100) !== -1}
                                  checkedIcon={<Check className={classes.checkedIcon} />}
                                  icon={<Check className={classes.uncheckedIcon} />}
                                  classes={{ checked: classes.checked, root: classes.checkRoot }}
                                />
                              }
                              classes={{ label: classes.label }}
                              label={item}
                            />
                          ))}
                        </div>
                      )
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem md={9} sm={12}>
            <GridContainer>
              {filteredProducts.map((item, index) => (
                <GridItem md={4} sm={6} xs={12} key={index}>
                  <Card product plain>
                    <CardHeader image plain>
                      <img src={item.image} alt={item.name} />
                      <div className={classes.coloredShadow} style={{ backgroundImage: `url(${item.image})`, opacity: 1 }} />
                    </CardHeader>
                    <CardBody className={classes.textCenter} plain>
                      <h4 className={classes.cardTitle}>{item.name}</h4>
                      <p className={classes.cardDescription}>{item.description}</p>
                    </CardBody>
                   <CardFooter plain style={{ justifyContent: "center", gap: "1rem" }}>
                      <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <Button justIcon target="_blank" href="https://www.trendyol.com" color="white">
                          <img src={trendyolLogo} alt="Trendyol" style={{ height: 24 }} />
                        </Button>
                        <Button justIcon target="_blank" href="https://www.hepsiburada.com" color="white">
                          <img src={hepsiburadaLogo} alt="Hepsiburada" style={{ height: 24 }} />
                        </Button>
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>
              ))}
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}